import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { all } from 'rsvp';
import Route from 'cio/routes/base';
import AuthService from 'cio/services/auth';
import SsoService from 'cio/services/sso';
import AccountService from 'cio/services/account';
import SettingsTeamIndexController from './controller';
import DS from 'ember-data';

export default class IndexRoute extends Route {
  @service auth!: AuthService;
  @service account!: AccountService;
  @service sso!: SsoService;
  @service store!: DS.Store;

  async model() {
    // .query instead of .findAll to avoid displaying all users in the store, specifically:
    // - new user (not yet saved)
    // - current user from different account (masquerading scenario)
    let usersPromise = this.store.query('user', {});

    let [users] = await all([usersPromise, this.sso.initialize()]);
    return { users, environments: this.auth.user?.accessibleEnvironments ?? [] };
  }

  resetController(controller: SettingsTeamIndexController, isExiting: boolean) {
    if (isExiting) {
      controller.setDefaults();
    }
  }

  @action
  refreshModel() {
    return this.refresh();
  }
}
